import { ONE_RADIAN_IN_DEGREES } from "../math/constants";

/**
 * Convert the given focal length (in millimeters) to a vertical field of view
 * in degrees appropriate to assign to THREE.PerspectiveCamera's fov property.
 */
export const focalLengthToVFov = (
    focalLength: number,
    filmGague: number = 35,
    aspect: number = 1.7777777777777777) =>
{
    const
        filmHeight = filmGague / Math.max(aspect, 1),
        slope = 0.5 * filmHeight / focalLength,
        vFovRad = 2 * Math.atan(slope),
        vFov = vFovRad * ONE_RADIAN_IN_DEGREES;
    return vFov;
};
export default focalLengthToVFov;
